<template>
  <div id="user-profile" class="container user-profile" style="max-width: 768px;">
    <div class="row pt-4">
      <div class="col-12">
        <h2 class="font-weight-bold user-profile__header">Your Profile</h2>
        <div class="user-profile__desc d-md-block d-none">Tells us a bit more</div>
        <div
            class="user-profile__desc d-md-none d-block"
        >Let's see how ready your team is to work from home.
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="about-me">About Me</div>
      <div class="row my-3 mx-auto">
        <div class="d-flex flex-column flex-md-row align-items-center align-items-md-stretch w-100">
          <div class="position-relative d-flex" style="cursor: pointer;border-radius: 50%;overflow: hidden" @click="selectAvatar">
            <user-avatar :avatarURL="user.avatar_src" size="136"></user-avatar>
            <div class="avatar-edit">Edit</div>
          </div>
          <div class="d-flex flex-column ml-md-5 ml-0 justify-content-center flex-fill">
            <div
                class="user-name font-weight-bold"
            >{{ originalUser.displayName || originalUser.name }}
            </div>
            <div class="member-since d-md-block d-none">
              Member Since
              {{ dateText }}
            </div>
            <div class="member-since d-md-none d-block">{{ originalUser.role }}</div>
            <div class="sum-remote-readiness d-flex justify-content-between align-items-center">
              <div class="sum-remote-readiness__text">Remote Readiness {{ rating }}</div>
              <a class="sum-remote-readiness__link" href="javascript:void(0);" @click="onClick">
                <span class="d-md-inline d-none">Edit Remote Readiness</span>
                <img v-bind:src="'/images/icon-arrow.svg'" alt/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <input
          type="file"
          ref="fileUpload"
          hidden
          accept="image/*"
          @change="updateProfileAvatar($event)"
      />

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="name" class="form-label">Full Name</label>
            <input
                class="form-control input-user-profile"
                type="text"
                id="name"
                name="name"
                v-model="user.name"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input
                class="form-control input-user-profile"
                type="email"
                id="email"
                name="email"
                v-model="user.email"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="company" class="form-label">Company</label>
            <input
                class="form-control input-user-profile"
                type="text"
                id="company"
                name="company"
                v-model="user.company"
                disabled
            />
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="designation" class="form-label">Designation</label>
            <input
                class="form-control input-user-profile"
                type="text"
                id="designation"
                name="designation"
                v-model="user.designation"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="password" class="form-label">Password</label>
            <input-password
                classes="input-user-profile"
                name="password"
                id="password"
                v-model="user.password"
            ></input-password>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label for="displayName" class="form-label">Display Name</label>
            <input
                class="form-control input-user-profile"
                type="text"
                id="displayName"
                name="displayName"
                v-model="user.displayName"
            />
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3" v-if="this.company.offices.length > 0">
          <div class="form-group">
            <label class="form-label">Offices and timezones</label>
            <select class="form-control input-user-profile" v-model="user.office">
              <option hidden :value="null">Please select a default office/timezone</option>
              <option
                  v-for="(office, key) in company.offices"
                  :value="office.id"
                  :key="key"
                  v-text="office.text"
              ></option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-label">Phone Number</label>
            <div class="input-group">
              <v-select
                  :clearable="false"
                  :reduce="country => country.country_calling_code"
                  :options="countries"
                  :filterable="true"
                  label="country_calling_code"
                  v-model="user.countryCallingCode"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.country_calling_code }} ({{ option.country_code }})
                  </div>
                </template>
              </v-select>
              <input type="text" class="form-control input-user-profile" aria-label="phone_number"
                     v-model="user.phoneNumber">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <button
                class="btn wfh-btn-primary"
                :disabled="!changeTriggered"
                @click="updateProfile"
            >Update Profile
            </button>
          </div>
        </div>
      </div>

      <form @submit.prevent="saveUserSocialMedia">
        <div class="row my-4">
          <div class="col">
            <div class="row">
              <div class="col">
                <h3 class="subheader">Social Media Links</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 mb-3" v-for="(socialMediaOption, key) in socialMediaOptions">
                <label :for="`soc-med-${key}`">{{ socialMediaOption.name }}</label>
                <input type="text" class="form-control input-user-profile" :id="`soc-med-${key}`" v-model="socialMediaOption.value">
              </div>
            </div>

            <div class="row my-3">
              <div class="col">
                <button type="submit" class="btn wfh-btn-primary" :disabled="!socialMediaUpdated">Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { calculate } from './ProfileRemoteReadinessCalculator';
import ImageCompressor from '../../ImageCompressor';
import vSelect from 'vue-select';

export default {
  components: { vSelect },

  data () {
    return {
      avatarFile: '',
      originalUser: {
        name: '',
        email: '',
        company: '',
        password: '',
        designation: '',
        avatar: '',
        office: null,
        displayName: '',
        memberSince: '',
        role: '',
        remoteReadiness: '',
        countryCallingCode: null,
        phoneNumber: null,
      },
      user: {
        name: '',
        email: '',
        password: '',
        company: '',
        designation: '',
        avatar: '',
        office: null,
        displayName: '',
        countryCallingCode: null,
        phoneNumber: null,
      },
      company: {
        pivot: {
          designation: '',
        },
        offices: [],
      },
      populateMap: {
        id: 'id',
        email: 'email',
        name: 'name',
        avatar: 'avatar',
        displayName: 'display_name',
        countryCallingCode: 'country_calling_code',
        phoneNumber: 'phone_number',
      },
      updatableFields: [
        'name',
        'displayName',
        'email',
        'password',
        'office',
        'designation',
        'phoneNumber',
        'countryCallingCode',
      ],
      countries: [],
      countryCallingCodes: [],
      socialMediaOptions: {},
      userSocialMedias: {},
    };
  },

  computed: {
    changeTriggered () {
      return (
          this.user.name !== this.originalUser.name ||
          this.user.displayName !== this.originalUser.displayName ||
          this.user.email !== this.originalUser.email ||
          this.user.office !== this.originalUser.office ||
          this.user.designation !== this.originalUser.designation ||
          this.user.countryCallingCode !== this.originalUser.countryCallingCode ||
          this.user.phoneNumber !== this.originalUser.phoneNumber ||
          this.user.password
      );
    },

    socialMediaUpdated () {
      for (const [slug, socialMediaOption] of Object.entries(this.socialMediaOptions)) {
        if (socialMediaOption.value !== this.userSocialMedias[slug].value) {
          return true;
        }
      }

      return false;
    },

    dateText () {
      if (this.originalUser.memberSince)
        return moment(this.originalUser.memberSince).format('D MMMM Y');
      return moment().format('D MMMM Y');
    },

    rating () {
      return `${calculate(this.originalUser.remoteReadiness)}%`;
    },

    currentUser () {
      return this.$store.state.currentUser;
    },
  },

  watch: {
    currentUser () {
      for (const [key, value] of Object.entries(this.populateMap)) {
        this.user[key] = this.currentUser[value];
        this.originalUser[key] = this.currentUser[value];
      }

      if (!this.originalUser.countryCallingCode) {
        this.user.countryCallingCode = '60';
      }

      this.company = this.currentUser.company;
      this.company.offices = this.company.offices ? this.company.offices : [];
      this.user.company = this.company.name;
      this.originalUser.company = this.company.name;
      this.user.designation = this.company.pivot.designation;
      this.originalUser.designation = this.company.pivot.designation;

      this.user.office = this.currentUser.office ? this.currentUser.office.id : null;
      this.originalUser.office = this.currentUser.office ? this.currentUser.office.id : null;
      this.originalUser.memberSince = this.currentUser.created_at;
      this.user.role = this.currentUser.role[0].name;
      this.originalUser.role = this.currentUser.role[0].name;
      this.originalUser.remoteReadiness = this.currentUser.remote_readiness;
    },
  },

  methods: {
    selectAvatar () {
      this.$refs.fileUpload.click();
    },

    async updateProfileAvatar (event) {
      const file = event.target.files[0];
      const imageSrc = file;
      const imageName = file.name;
      const fileType = file.type.split('/')[1];
      const imageBlob = window.URL.createObjectURL(imageSrc);

      const resizedImage = await ImageCompressor(imageBlob, imageName, fileType);

      let formData = new FormData();
      formData.append('avatar', resizedImage);

      await axios.post('profile-avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      location.reload();
    },

    async updateProfile () {
      const updateParams = {};

      for (let updatableField of this.updatableFields) {
        if (this.user[updatableField] !== this.originalUser[updatableField]) {
          updateParams[this.populateMap[updatableField] ?? updatableField] = this.user[updatableField];
        }
      }

      await axios.post(`profile/${this.user.id}`, updateParams);

      window.scrollTo(0, 0);
      location.reload();
    },

    onClick () {
      this.$emit('onClick');
    },

    async getCountriesList () {
      this.countries = await axios.get('/options/countries').then(res => res.data.data);
    },

    async getSocialMediaOptions () {
      const options = {};
      const resOptions = await axios.get('/options/social-medias').then(res => res.data.data);

      for (const socialMedia of resOptions) {
        let value = null;

        if (this.currentUser.socialMedias.length > 0) {
          for (const userSocialMedia of this.currentUser.socialMedias) {
            if (socialMedia.id === userSocialMedia.id) {
              value = userSocialMedia.pivot.link;
            }
          }
        }

        options[socialMedia.slug] = {
          id: socialMedia.id,
          name: socialMedia.name,
          value: value,
        }

        this.userSocialMedias[socialMedia.slug] = {
          id: socialMedia.id,
          name: socialMedia.name,
          value: value,
        }
      }

      this.socialMediaOptions = options;
    },

    async saveUserSocialMedia () {
      const updatedFields = [];

      for (const socialMedia of Object.values(this.socialMediaOptions)) {
        if (socialMedia.value !== null) {
          updatedFields.push({
            id: socialMedia.id,
            value: socialMedia.value,
          })
        }
      }

      await axios.post(`/users/${this.currentUser.id}/social-medias`, {
        social_media: updatedFields,
      });

      location.reload();
    },
  },

  mounted () {
    this.getCountriesList();
    this.getSocialMediaOptions();
  },
};
</script>

<style scoped lang="scss">
.user-profile {
  &__header {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 53.2px;
    text-align: center;
    @media (max-width: 768px) {
      text-align: left;
      font-size: 24px;
      margin-bottom: 0;
    }
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;

    @media (max-width: 768px) {
      text-align: left;
      font-size: 14px;
    }
  }

  .about-me {
    color: #222227;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }

  .user-name {
    color: #333;
    font-family: "Open Sans", sans-serif;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 43px;
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  .member-since {
    color: #8392a6;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 24px;
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  .sum-remote-readiness {
    margin-top: 16px;

    &__text {
      color: #8392a6;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0;
      line-height: 24px;
    }

    &__link {
      color: #0db4e6;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
    }
  }

  .input-user-profile {
    color: #303030;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    background: white;
    border: 1px solid #dce2ed;
  }

  label {
    color: #808fa4;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 22px;
  }

  .btn {
    border-radius: 6px;
    background-color: #000;

    border: none;
    color: #fff;
  }

  .btn-save {
    height: 56px;
    width: 320px;
    color: #fff;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    background: #000;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .avatar-edit {
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 151, 244, 0.75);
    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    font-weight: bold;
  }
}

:disabled {
  opacity: 0.5;
}

input,
select,
textarea {
  border-radius: 3px;
  background-color: #f2f2f2;
  border: none;
}

.name,
.designation,
.sub {
  color: #00002d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 17px;
  margin: 0;
}

.sub {
  color: #9696a8;
  font-size: 10px;
  line-height: 12px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.41);
}

.subheader {
  font-family: Lato, sans-serif;
}
</style>
